/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, render, Mutation, SelectionSet, Field, IdScalar } from "graphql-jsx";
import { ValidTypeScalar } from "GraphQL/Scalars";
import { ValidType } from "constants/ValidType";

type Option = Readonly<{
  id: string;
  validCheck: ValidType;
}>;

export const UpdateArtistVC = async (option: Option) => {
  const $id = <Variable name="id" scalar={<IdScalar />} value={option.id} />;
  const $validCheck = <Variable name="validCheck" scalar={<ValidTypeScalar />} value={option.validCheck} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_ARTIST">
      <SelectionSet
        name="updateArtist"
        argument={{
          where: {
            artist_id: $id
          },
          data: {
            valid_check: $validCheck
          }
        }}
      >
        <Field name="artist_id" />
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    updateArtist: {
      id: string;
    };
  }>;

  return await clients.artist.request<Data>(query, variables);
};
